module.exports = __webpack_public_path__ + "media/images/frontend/heros/aboutus-aec2c9a6a3b4b69cb74cd85c7d99279c.jpg";